// removed by extract-text-webpack-plugin
module.exports = {"block":"_3WvNtwVzT4K-ThiD4iHKSd","column":"_1AOnJDTfchdzHO_jiz0S8c","info":"_3cZIsGn3oAxCSlWYQ2ag5R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectInfoBlock/ProjectInfoBlock.module.scss
// module id = 798
// module chunks = 0